// Caché para evitar cargar los datos múltiples veces
let catalogoCache = null;
let articulosCache = null;

const loadCatalogoData = async () => {
  if (!catalogoCache) {
    try {
      const response = await fetch("/json/catalogo.json");
      catalogoCache = await response.json();
    } catch (error) {
      console.error("Error loading catalogo data:", error);
      return { items: [], totalCount: 0 };
    }
  }
  return catalogoCache;
};

const loadArticulosData = async () => {
  if (!articulosCache) {
    try {
      const response = await fetch("/json/articulos.json");
      articulosCache = await response.json();
    } catch (error) {
      console.error("Error loading articulos data:", error);
      return { items: [], totalCount: 0 };
    }
  }
  return articulosCache;
};

const getCatalogoItems = async (page = 1, pageSize = 10, filtro = "", soloActivos = true) => {
  const catalogoData = await loadCatalogoData();

  let items = catalogoData.items || [];

  // Filtrar por texto si se proporciona
  if (filtro && filtro.trim()) {
    items = items.filter(item => item.descripcion?.toLowerCase().includes(filtro.toLowerCase()));
  }

  // Filtrar solo activos si se solicita
  if (soloActivos) {
    items = items.filter(item => item.activo !== false);
  }

  // Implementar paginación
  const totalCount = items.length;
  const totalPages = Math.ceil(totalCount / pageSize);
  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedItems = items.slice(startIndex, endIndex);

  return {
    items: paginatedItems,
    pageNumber: page,
    pageSize,
    totalCount,
    totalPages,
    hasNextPage: page < totalPages,
    hasPreviousPage: page > 1,
  };
};

const getArticulosItems = async (page = 1, pageSize = 10, filtro = "", id) => {
  const articulosData = await loadArticulosData();

  let items = articulosData.items || [];

  // Si se pasa un id, filtrar los artículos por idGrupoArticulo
  if (id) {
    items = items.filter(articulo => articulo.idGrupoArticulo === id);
  }

  // Filtrar por texto si se proporciona
  if (filtro && filtro.trim()) {
    items = items.filter(
      articulo => articulo.descripcion?.toLowerCase().includes(filtro.toLowerCase()) || articulo.codigo?.toLowerCase().includes(filtro.toLowerCase()),
    );
  }

  // Implementar paginación
  const totalCount = items.length;
  const totalPages = Math.ceil(totalCount / pageSize);
  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedItems = items.slice(startIndex, endIndex);

  return {
    items: paginatedItems,
    pageNumber: page,
    pageSize,
    totalCount,
    totalPages,
    hasNextPage: page < totalPages,
    hasPreviousPage: page > 1,
  };
};

const catalogo = {
  getCatalogoItems,
  getArticulosItems,
};

export default catalogo;
